import React, { PureComponent } from 'react'
import { ClipLoader } from 'react-spinners'
import * as Yup from 'yup'

import MultiSelect from '@components/MultiSelect'
import { Formik, Form, Currency, Number } from '@components/Form'
import CitySearch from '@components/CitySearch'

import { formatToLocale } from '@utils/numberFormatter'

import NeighborhoodFilter from '@components/NeighborhoodFilter'

import SearchBar from '@components/SearchBar'

import {
  FilterBar,
  Header,
  HeaderMain,
  Dock,
  IconWrapper,
  ClearFilter,
  Body,
  FilterLabel,
  ValueWrapper,
  Input,
  FeaturesContainer,
  Feature,
  Button,
  Error,
  Footer,
  PriceContainer,
  Text,
  TextWrapper,
  GeneralContainer,
  Option,
  SectionTitle,
} from './styles'

import SelectComponent from '../Form/Select'
import { DoubleArrowLeft, Close, SearchIcon, Checkbox } from '@icons'

import './index.css'

const SearchSchema = Yup.object().shape({
  main_sub_category: Yup.string().required('Obrigatório'),
  main_area: Yup.number().required('Obrigatório'),
  category: Yup.object().required('Obrigatório'),
  area: Yup.number().required('Obrigatório'),
})

const oneToSevenOptions = [
  { name: '1', label: '1' },
  { name: '2', label: '2' },
  { name: '3', label: '3' },
  { name: '4', label: '4' },
  { name: '5', label: '5' },
  { name: '6', label: '6' },
  { name: '7', label: '7+' },
]

const zeroToSevenOptions = [{ name: '0', label: '0' }].concat(oneToSevenOptions)

class FilterBarComponent extends PureComponent {
  submitForm = values => {
    const { submitFilters, setFilterValues } = this.props
    setFilterValues(values)
    submitFilters()
  }

  getMargin = (values, operation = 'add', money = false) => {
    const margin = (values.value * values.margin) / 100
    let value = 0

    if (operation === 'subtract') {
      value = values.value - margin
    } else {
      value = values.value + margin
    }

    return money ? formatToLocale(value) : value?.toFixed(0) || 0
  }

  render() {
    const {
      active,
      onClose,
      setFilterValues,
      loading,
      amenities,
      neighborhoods,
      selectNeighborhood,
      selectedNeighborhood,
      valuationService,
      setCity,
      currentCityName,
      mapService,
      setRadiusInfo,
      searchInitialState,
    } = this.props

    return (
      <FilterBar active={active}>
        <Header>
          {active && (
            <HeaderMain>
              <IconWrapper searchBar={active}>
                <SearchIcon gray width={20} height={20} />
              </IconWrapper>
              <SearchBar
                fullBorder
                initialState={searchInitialState}
                active={active}
                mapService={mapService}
                setRadiusInfo={setRadiusInfo}
              />
            </HeaderMain>
          )}
          <Dock onClick={onClose}>
            <DoubleArrowLeft color="white" height={11.19} />
          </Dock>
        </Header>
        <Body>
          <Formik
            validationSchema={SearchSchema}
            initialValues={{
              main_sub_category: undefined,
              main_bedrooms: '',
              main_garages: '',
              main_suites: '',
              main_area: '',
              privateBusiness: '',
              category: undefined,
              area: '',
              areaPercentMargin: 20,
              sqrMeterPrice: '',
              pricePercentMargin: 20,
              bedrooms: [],
              suites: [],
              garages: [],
              amenities: undefined,
              alpha: 10,
              beta: 50,
              recentOnly: false,
            }}
            onSubmit={this.submitForm}
          >
            {({
              handleSubmit,
              handleReset,
              handleChange,
              values,
              setFieldValue,
              submitCount,
              isValid,
              errors,
            }) => {
              const shouldDisplayArea = !!(
                values.area &&
                values.areaPercentMargin &&
                values.area !== 0 &&
                values.areaPercentMargin !== 0
              )
              const shouldDisplayPrice = !!(
                values.sqrMeterPrice &&
                values.pricePercentMargin &&
                values.sqrMeterPrice !== 0 &&
                values.pricePercentMargin !== 0
              )

              this.resetForm = handleReset
              this.formValues = values
              this.changeFieldValue = setFieldValue
              this.submitFilters = handleSubmit

              submitCount > 0 &&
                !isValid &&
                this.firstItem?.scrollIntoView({ behavior: 'smooth' })

              setFilterValues(isValid ? values : null)
              return (
                <Form onSubmit={handleSubmit}>
                  <SectionTitle>Informações do Imóvel</SectionTitle>
                  <FilterLabel>
                    Cidade{currentCityName && `: ${currentCityName}`}
                  </FilterLabel>
                  <CitySearch
                    valuationService={valuationService}
                    setCity={setCity}
                  />
                  {neighborhoods && (
                    <React.Fragment>
                      <FilterLabel>Bairro</FilterLabel>
                      <NeighborhoodFilter
                        name="neighborhood"
                        selectedNeighborhood={selectedNeighborhood}
                        onChange={selectNeighborhood}
                        options={neighborhoods}
                      />
                    </React.Fragment>
                  )}
                  <FilterLabel>Tipo de imóvel</FilterLabel>
                  <SelectComponent
                    category
                    name="main_sub_category"
                    placeholder="Selecione"
                    value={values.main_sub_category}
                    options={[]}
                    onChange={obj => {
                      setFieldValue('main_sub_category', obj)
                      if (
                        !values.category ||
                        Object.keys(values.category).length <= 1
                      ) {
                        setFieldValue('category', { [obj.value]: true })
                      }
                    }}
                  />
                  {errors.main_sub_category && (
                    <Error>{errors.main_sub_category}</Error>
                  )}
                  <FeaturesContainer>
                    <Feature>
                      <FilterLabel>Quartos</FilterLabel>
                      <Number
                        placeholder="N/A"
                        inputWidth="100%"
                        countWidth="72%"
                        name="main_bedrooms"
                        value={values.main_bedrooms}
                        onChange={e => {
                          handleChange(e)
                          if (
                            !values.bedrooms ||
                            Object.keys(values.bedrooms).length <= 1
                          ) {
                            values.bedrooms = {}
                            values.bedrooms[
                              e.target.value < 7 ? e.target.value : 7
                            ] = true
                          }
                        }}
                      />
                    </Feature>
                    <Feature>
                      <FilterLabel>Suítes</FilterLabel>
                      <Number
                        placeholder="N/A"
                        inputWidth="100%"
                        countWidth="72%"
                        name="main_suites"
                        value={values.main_suites}
                        onChange={e => {
                          handleChange(e)
                          if (
                            !values.suites ||
                            Object.keys(values.suites).length <= 1
                          ) {
                            values.suites = {}
                            values.suites[
                              e.target.value < 7 ? e.target.value : 7
                            ] = true
                          }
                        }}
                      />
                    </Feature>
                    <Feature>
                      <FilterLabel>Garagens</FilterLabel>
                      <Number
                        placeholder="N/A"
                        inputWidth="100%"
                        countWidth="72%"
                        name="main_garages"
                        value={values.main_garages}
                        onChange={e => {
                          handleChange(e)
                          if (
                            !values.garages ||
                            Object.keys(values.garages).length <= 1
                          ) {
                            values.garages = {}
                            values.garages[
                              e.target.value < 7 ? e.target.value : 7
                            ] = true
                          }
                        }}
                      />
                    </Feature>
                  </FeaturesContainer>
                  <FilterLabel>Área</FilterLabel>
                  <Input
                    name="main_area"
                    type="number"
                    placeholder="Área (em m²)"
                    value={values.main_area}
                    onChange={e => {
                      handleChange(e)
                      values.area = parseFloat(e.target.value)
                    }}
                    fullWidth
                  />
                  {errors.main_area && <Error>{errors.main_area}</Error>}
                  <SectionTitle>Informações da Amostra</SectionTitle>
                  <FilterLabel ref={el => (this.firstItem = el)}>
                    Tipo de imóvel
                  </FilterLabel>
                  <MultiSelect
                    category
                    name="category"
                    values={values.category}
                    onChange={(name, values) => {
                      setFieldValue(name, values)
                    }}
                  />
                  {errors.category && <Error>{errors.category}</Error>}
                  <PriceContainer>
                    <ValueWrapper width="60%">
                      <FilterLabel>Área</FilterLabel>
                      <Input
                        name="area"
                        type="number"
                        placeholder="Área (em m²)"
                        value={values.area}
                        onChange={handleChange}
                      />
                      {errors.area && <Error>{errors.area}</Error>}
                    </ValueWrapper>
                    <ValueWrapper width="40%">
                      <FilterLabel>Margem (%)</FilterLabel>
                      <Number
                        inputWidth="100%"
                        countWidth="72%"
                        name="areaPercentMargin"
                        value={values.areaPercentMargin}
                        onChange={handleChange}
                      />
                    </ValueWrapper>
                  </PriceContainer>
                  {shouldDisplayArea && (
                    <div>
                      <Text>
                        Área Min:
                        {this.getMargin(
                          {
                            value: values.area,
                            margin: values.areaPercentMargin,
                          },
                          'subtract',
                        )}
                      </Text>
                      <Text>
                        Área Max:
                        {this.getMargin({
                          value: values.area,
                          margin: values.areaPercentMargin,
                        })}
                      </Text>
                    </div>
                  )}
                  <PriceContainer>
                    <ValueWrapper width="60%">
                      <FilterLabel>Valor m²</FilterLabel>
                      <Currency
                        noMargin
                        placeholder="Valor m²"
                        classes="filter-input-active"
                        value={values.sqrMeterPrice}
                        onChange={({ floatValue }) =>
                          setFieldValue('sqrMeterPrice', floatValue || 0)
                        }
                      />
                    </ValueWrapper>
                    <ValueWrapper width="40%">
                      <FilterLabel>Margem (%)</FilterLabel>
                      <Number
                        inputWidth="100%"
                        countWidth="72%"
                        name="pricePercentMargin"
                        value={values.pricePercentMargin}
                        onChange={handleChange}
                      />
                    </ValueWrapper>
                  </PriceContainer>
                  {shouldDisplayPrice && (
                    <div>
                      <Text>
                        Valor m² min:{' '}
                        {this.getMargin(
                          {
                            value: values.sqrMeterPrice,
                            margin: values.pricePercentMargin,
                          },
                          'subtract',
                          true,
                        )}
                      </Text>
                      <Text>
                        Valor m² max:{' '}
                        {this.getMargin(
                          {
                            value: values.sqrMeterPrice,
                            margin: values.pricePercentMargin,
                          },
                          'add',
                          true,
                        )}
                      </Text>
                    </div>
                  )}
                  <FeaturesContainer>
                    <Feature>
                      <FilterLabel>Quartos</FilterLabel>
                      <MultiSelect
                        name="bedrooms"
                        values={values.bedrooms}
                        options={oneToSevenOptions}
                        onChange={(name, values) => {
                          setFieldValue(name, values)
                        }}
                      />
                    </Feature>
                    <Feature>
                      <FilterLabel>Suítes</FilterLabel>
                      <MultiSelect
                        name="suites"
                        values={values.suites}
                        options={zeroToSevenOptions}
                        onChange={(name, values) => {
                          setFieldValue(name, values)
                        }}
                      />
                    </Feature>
                    <Feature>
                      <FilterLabel>Garagens</FilterLabel>
                      <MultiSelect
                        name="garages"
                        values={values.garages}
                        options={zeroToSevenOptions}
                        onChange={(name, values) => {
                          setFieldValue(name, values)
                        }}
                      />
                    </Feature>
                  </FeaturesContainer>
                  <FilterLabel ref={el => (this.lastItem = el)}>
                    Opcionais
                  </FilterLabel>
                  <MultiSelect
                    name="amenities"
                    disabled={!amenities}
                    values={values.amenities}
                    options={amenities}
                    onChange={(name, values) => {
                      setFieldValue(name, values)
                    }}
                  />
                  <GeneralContainer>
                    <Option
                      title="Ao selecionar esta opção, a busca por amostra trará apenas anúncios que tiveram atualizações nos últimos 7 dias."
                      onClick={() =>
                        setFieldValue('recentOnly', !values.recentOnly)
                      }
                    >
                      <Checkbox checked={values.recentOnly} />
                      <Text fontSize="default" noMargin>
                        Apenas anúncios recentes
                      </Text>
                    </Option>
                  </GeneralContainer>
                </Form>
              )
            }}
          </Formik>
        </Body>
        <Footer>
          <Button
            type="button"
            disabled={loading}
            onClick={loading ? null : this.submitFilters}
          >
            <TextWrapper>Gerar Amostra</TextWrapper>
            {loading && <ClipLoader sizeUnit="px" size={16} color="#454E5B" />}
          </Button>
          <ClearFilter onClick={this.resetForm}>
            <IconWrapper>
              <Close gray width={10} height={10} />
            </IconWrapper>
            Limpar filtros
          </ClearFilter>
        </Footer>
      </FilterBar>
    )
  }
}

export default FilterBarComponent
